import { useDispatch } from 'react-redux'
import {
  SUPPORT_CONNECTION_PROBLEMS_STEPS,
  SUPPORT_STATUS,
  SUPPORT_STATUS_CTA_LABEL,
  SUPPORT_STATUS_TITLE,
} from 'app-constants'
import { AICard } from 'components'
import { STATICS } from 'statics'
import { sendWhatsappMessage } from 'utils'
import './style.scss'

export function OtherConnectionProblems({ data }) {
  const { detailedMessage } = data
  const dispatch = useDispatch()

  function handleCtaTalkAttendantClick() {
    dispatch(sendWhatsappMessage)
  }

  function renderConnectionProblemsSteps() {
    return SUPPORT_CONNECTION_PROBLEMS_STEPS.map(step => (
      <li className='step' key={step}>
        <STATICS.ACTIVE_DOT className='dot' />
        {step}
      </li>
    ))
  }

  return (
    <div className='support-other-connection-problems'>
      <AICard
        title={SUPPORT_STATUS_TITLE[SUPPORT_STATUS.OTHER_CONNECTION_PROBLEMS]}
        message={detailedMessage}
        ctaLabel={SUPPORT_STATUS_CTA_LABEL.TALK_WITH_ATTENDANT}
        onCtaClick={handleCtaTalkAttendantClick}
      >
        <ul className='steps'>{renderConnectionProblemsSteps()}</ul>
      </AICard>
    </div>
  )
}
